export default __webpack_public_path__ + "static/media/hero-apron.339d278d.jpg";